import React from 'react';

interface DataPreviewProps {
  data: any[];
  columns: string[];
  isLoading?: boolean;
}

const DataPreview: React.FC<DataPreviewProps> = ({ data, columns }) => {
    
  return (
    <div className="data-preview">
        <h3>Data Preview</h3>
        {data.length > 0 ? (
            <table>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {/* data.slice(0, 5) for fewer rows */}
                    {data.slice(0, 100).map((row, index) => (
                        <tr key={index}>
                            {columns.map((col) => (
                                <td key={col}>{row[col]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : (
            <p>No data available for preview.</p>
        )}
    </div>
  );
};

export default DataPreview; 